export const CREATE_SHIPPING_LABEL_EXCLUDED_ORGS = [2096, 2113, 595, 2002]
